import Client from './helpers/client'
require('dotenv').config()

const url = process.env.REACT_APP_FINANCE_API || 'http://localhost:3004';
const api = new Client(url);

export default api;